module.exports = __webpack_public_path__ + "static/kalkhoff-endeavour-7b-advance-2021-ee7668ce7a6598137dd20508f8b278c8.jpg";